import { createApp } from 'vue';
import GlobalServiceNavigation from './GlobalServiceNavigation.vue';
import '@coloplast/design-system/dist/components/nav/service/ds-nav-service.css';

const globalServiceNavigationMountElem = document.querySelector(
	'[data-feature="global-service-navigation"]',
);

if (globalServiceNavigationMountElem) {
	const app = createApp({
		name: 'GlobalServiceNavigationApp',
	});
	app.component('global-service-navigation', GlobalServiceNavigation);
	app.mount(globalServiceNavigationMountElem);
}

